export default __webpack_public_path__ + "static/media/01_galaxys21_plus_phantom_violet_front.b7bfd7ef.png";